import type {
  Options,
  Result,
  Service,
} from "ahooks/lib/useRequest/src/types";
import { useRequest as useRequestOriginal } from "ahooks";
import { App } from "antd";

function useRequest<TData = any, TParams extends any[] = any>(
  service: Service<TData, TParams>,
  options?: Options<TData, TParams>
): Result<TData, TParams> {
  const { message } = App.useApp();

  const defaultOnError = (err: Error) => {
    message.error(err.message || "Алдаа гарлаа");
  };

  const mergedOptions: Options<TData, TParams> = options
    ? {
      ...options,
      onError: options.onError || defaultOnError,
    }
    : {
      onError: defaultOnError,
    };

  return useRequestOriginal(service, mergedOptions);
}

export default useRequest;
